'use strict';

exports.__esModule = true;
exports.isPromise = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/lib/PromiseUtils.js
// module id = 1773
// module chunks = 25